import types from '@/modules/utils/Form/types'
import data from '@/modules/utils/Form/data'

const Form = {
  types: types,
  data: data
}

export default Form
